/* Hey Collette: one-tap add-ons in the cart drawer. Adds the chosen variant, then hands the
   fresh section HTML to the theme so the drawer, bar and cart count all update in place. */
(() => {
  if (window.__hcCartBoost) return;
  window.__hcCartBoost = true;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const sectionIds = () => {
    const ids = new Set(['cart-drawer-section']);
    document.querySelectorAll('cart-items-component[data-section-id]').forEach((el) => ids.add(el.dataset.sectionId));
    return Array.from(ids);
  };

  const showError = (card, message) => {
    const el = card.querySelector('.hc-addon__error');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
  };

  async function refresh(variantId, sections) {
    try {
      const { CartLinesUpdateEvent } = await import('@shopify/events');
      const cart = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
      const deferred = CartLinesUpdateEvent.createPromise();
      document.dispatchEvent(
        new CartLinesUpdateEvent({
          action: 'add',
          context: 'cart',
          lines: [{ id: String(variantId), quantity: 1 }],
          promise: deferred.promise,
        })
      );
      let cartObject = cart;
      try {
        cartObject = CartLinesUpdateEvent.createCartFromAjaxResponse(cart);
      } catch (_) {}
      deferred.resolve({
        cart: cartObject,
        detail: { sections, itemCount: cart.item_count, source: 'hc-cart-addons', didError: false },
      });
    } catch (error) {
      try {
        const { sectionRenderer } = await import('@theme/section-renderer');
        await sectionRenderer.renderSection('cart-drawer-section', { cache: false, mode: 'hydration' });
      } catch (_) {
        window.location.reload();
      }
    }
  }

  document.addEventListener('change', (event) => {
    const field = event.target;
    if (field instanceof HTMLSelectElement && field.matches('.hc-addon__size')) {
      field.classList.remove('is-invalid');
      const err = field.closest('.hc-addon')?.querySelector('.hc-addon__error');
      if (err) err.hidden = true;
    }
  });

  document.addEventListener('click', async (event) => {
    const button = event.target instanceof Element ? event.target.closest('[data-hc-add]') : null;
    if (!button) return;
    const card = button.closest('.hc-addon');
    const field = card?.querySelector('[data-hc-variant]');
    const variantId = field?.value;

    if (!variantId) {
      field?.classList.add('is-invalid');
      field?.focus();
      showError(card, 'Choose a size first');
      return;
    }

    const label = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding…';

    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1 }],
          sections: sectionIds().join(','),
          sections_url: window.location.pathname,
        }),
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || 'That size could not be added');
      await refresh(variantId, data.sections || {});
    } catch (error) {
      button.disabled = false;
      button.textContent = label;
      showError(card, error.message || 'That size could not be added');
    }
  });
})();
